import React from 'react';
import type { LDClient } from 'launchdarkly-js-client-sdk';

import type { FeatureFlagContextShape } from './types';

export function createFeatureFlagContext<Flags>(defaults: Flags) {
  return React.createContext<FeatureFlagContextShape<Flags>>({
    flags: defaults,
    activeFlagNames: [],
    _client: {} as LDClient,
    loadingState: 'loading',
    error: undefined,
    setUser: async () => {},
    unsetUser: async () => {},
    subscribe: async () => {},
  });
}
